import { CommonModule } from '@angular/common';
import { Component, Input, Optional, Self } from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    FormsModule,
    NgControl,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'ed-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatFormFieldModule],
})
export class SelectComponent implements ControlValueAccessor {
    @Input()
    public innerId: string = '';

    @Input()
    public options: { value: string | number; label: string; disabled?: boolean }[] = [];

    @Input()
    public placeholder: string = '';

    @Input()
    public disableRipple: boolean = false;

    @Input()
    public disableOptionCentering: boolean = false;

    @Input()
    public disabled: boolean = false;

    public value: any;

    private _onModelChange: (a: any) => any = () => {};
    private _onTouched: () => any = () => {};

    public get control(): AbstractControl | null {
        return this.ngControl ? this.ngControl.control : null;
    }

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    changeValue(value: any): void {
        this.value = value;
        this._onModelChange(value);
    }

    writeValue(value: any): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this._onModelChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }
}
